Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing;
  var container = {
    flexDirection: 'column',
    alignItems: 'center'
  };
  var textContainer = {
    marginTop: spacing.l
  };
  var _text = Object.assign({}, fontBold, {
    textAlign: 'center',
    color: colors.brand
  });
  var _textInner = Object.assign({}, _text, {
    position: 'absolute',
    zIndex: 0,
    left: 0,
    right: 0
  });
  var textInnerValue = Object.assign({}, _textInner, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  var textInnerType = Object.assign({}, _textInner, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var textValue = Object.assign({}, _text, {
    fontSize: _styles.STYLES.fontSize.xl,
    lineHeight: _styles.STYLES.lineHeight.xl
  });
  var textType = Object.assign({}, _text, {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m
  });
  var description = Object.assign({}, fontRegular, {
    textAlign: 'center',
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    marginTop: spacing.s
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    textContainer: textContainer,
    textInnerValue: textInnerValue,
    textInnerType: textInnerType,
    textValue: textValue,
    textType: textType,
    description: description
  });
  return {
    styles: styles
  };
};